import React from 'react'
import PropTypes from 'prop-types'
import { useField, ErrorMessage } from 'formik'

// Shared Styled Elements
import { Wrapper, FormLabel, FormErrorMessage } from '../SharedStyles.element'

// Styled Elements
import { FormTextAreaInput } from './FormTextArea.elements'

function FormTextArea(props) {
  // Destructure
  const { type, label, resize, disabled, ...rest } = props

  // Hooks
  const [fields] = useField(props)

  return (
    <Wrapper label={label}>
      {label && <FormLabel disabled={disabled}>{label}</FormLabel>}
      <FormTextAreaInput disabled={disabled} type={type} resize={resize} {...fields} {...rest} />
      <FormErrorMessage>
        <ErrorMessage {...fields} />
      </FormErrorMessage>
    </Wrapper>
  )
}

// Default Props
FormTextArea.defaultProps = {
  type: '',
  label: '',
  resize: true,
  disabled: false,
}

// Proptypes Validation
FormTextArea.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string,
  resize: PropTypes.bool,
  disabled: PropTypes.bool,
}

export default FormTextArea
